import React from 'react';
import { FaUniversity } from 'react-icons/fa';
import './InstitutionalSignature.css';

const BRAND_ASSETS = [
  {
    key: 'ifes',
    name: 'Instituto Federal do Espírito Santo',
    shortName: 'IFES',
    role: 'Instituto Federal',
    src: '/identidade-institucional/ifes.png',
  },
  {
    key: 'cefet-mg',
    name: 'Centro Federal de Educação Tecnológica de Minas Gerais',
    shortName: 'CEFET-MG',
    role: 'Centro Federal',
    src: '/identidade-institucional/cefet-mg.svg',
  },
  {
    key: 'cefet-rj',
    name: 'Centro Federal de Educação Tecnológica Celso Suckow da Fonseca',
    shortName: 'CEFET/RJ',
    role: 'Centro Federal',
    src: '/identidade-institucional/cefet-rj.png',
  },
  {
    key: 'cpii',
    name: 'Colégio Pedro II',
    shortName: 'CPII',
    role: 'Colégio Federal',
    src: '/identidade-institucional/cpii.png',
  },
];

// Na faixa compacta a marca exibida é a da Rede Federal (símbolo sem texto),
// e não a marca completa do IFES: a faixa representa a rede como um todo.
const MINIMAL_ASSETS = [
  {
    key: 'rede-federal',
    name: 'Rede Federal de Educação Profissional, Científica e Tecnológica',
    src: '/identidade-institucional/rede-federal.png',
  },
  ...BRAND_ASSETS.filter((b) => b.key !== 'ifes'),
];

const InstitutionalSignature = ({ variant = 'full', className = '' }) => {
  if (variant === 'compact') {
    return (
      <div className={`institutional-signature institutional-signature--compact ${className}`.trim()} aria-label="MAGO para a Rede Federal">
        <span className="institutional-compact-divider" aria-hidden="true" />
        <FaUniversity className="institutional-compact-icon" aria-hidden="true" />
        <span className="institutional-compact-copy">
          <strong>Rede Federal</strong>
          <small>Desenvolvido pelo IFES</small>
        </span>
      </div>
    );
  }

  if (variant === 'minimal') {
    return (
      <div className={`institutional-signature institutional-signature--minimal ${className}`.trim()} aria-label="Identidade institucional da Rede Federal">
        <span className="institutional-minimal-label">Rede Federal</span>
        {MINIMAL_ASSETS.map((brand) => (
          <img key={brand.key} src={brand.src} alt={`Marca ${brand.name}`} title={brand.name} />
        ))}
      </div>
    );
  }

  return (
    <section className={`institutional-signature institutional-signature--${variant} ${className}`.trim()} aria-label="Identidade institucional da Rede Federal">
      <div className="institutional-signature-copy">
        <span className="institutional-eyebrow">Rede Federal</span>
        <strong>Uma solução desenvolvida pelo IFES</strong>
        <p>Para apoiar a governança da Rede Federal de Educação Profissional, Científica e Tecnológica.</p>
      </div>

      <div className="institutional-brand-grid" aria-label="Instituições representadas">
        {BRAND_ASSETS.map((brand) => (
          <div className={`institutional-brand institutional-brand--${brand.key}`} key={brand.key}>
            <img src={brand.src} alt={`Marca ${brand.name}`} />
            <span>
              <strong>{brand.shortName}</strong>
              <small>{brand.role}</small>
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default InstitutionalSignature;
